import { useEffect, useState } from "react";
import { LoadingSpinner, ModalMessage, ReviewForm, ReviewsList, SortDropdown, PaginationMenu } from "../../components";
import { Container, Row, Col } from "react-bootstrap";
import { deleteProductReviewApi, fetchUserReviewsApi } from "../../api/reviewsApi";
import { ScrollToTop, getStorageToken } from "../../utilities";
import { useSelector } from "react-redux";


export default function UserReviewsList() {
  // displays a list of all the reviews the user has submitted
  // the user can edit/delete previously submitted reviews

  const initialPaginationState = {
    pageNr: 1,
    totalNrOfPages: 1,
  };
  
  const sortOptions = [
    { value: "createdAt_-1", label: "Newest" },
    { value: "createdAt_1", label: "Oldest" },
    { value: "productName_1", label: "Product Name: A-Z" },
    { value: "productName_-1", label: "Product Name: Z-A" },
  ];
  
  const filterOptions = [
    { value: "", label: "None" },
    { value: "rating_5", label: "5 Stars" },
    { value: "rating_4", label: "4 Stars" },
    { value: "rating_3", label: "3 Stars" },
    { value: "rating_2", label: "2 Stars" },
    { value: "rating_1", label: "1 Star" },
  ];  

  const { stayLoggedIn } = useSelector((state) => state.user);

  const [reviews, setReviews] = useState([]);
  const [editReview, setEditReview] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [updateReviews, setUpdateReviews] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const [paginationState, setPaginationState] = useState(
    {...initialPaginationState}
  );
  const [sortOption, setSortOption] = useState(sortOptions[0]?.value);
  const [filterOption, setFilterOption] = useState(filterOptions[0]?.value);

  useEffect(() => {
    const fetchReviews = async (pageNr = null) => {
      try {
        setIsLoading(true);
        const token = getStorageToken(stayLoggedIn);
        const abortController = new AbortController();
        const res = await fetchUserReviewsApi(
          token,
          abortController.signal,
          sortOption,
          filterOption,
          pageNr
        );
        setIsLoading(false);
        return res;
      } catch (error) {
        setErrorMsg("Could not load reviews data. Please try again later.");
      }
    };
    
    setUpdateReviews(false);
    const pageNr = paginationState?.pageNr || 1;
    fetchReviews(pageNr)
      .then((res) => {
        setReviews(res.reviews);
        setPaginationState({
          pageNr: res?.currPageNr || 1, 
          totalNrOfPages: res?.totalNrOfPages || 1,
        })
      })
      .catch((error) =>
        setErrorMsg("Could not load data. Please try again later.")
      );
  }, [updateReviews, filterOption, sortOption, paginationState?.pageNr, stayLoggedIn]);



  const handleChangePageNr = (newPageNr) => {
    if (newPageNr < 1) {
      newPageNr = 1;
    } else if (newPageNr > paginationState.totalNrOfPages) {
      newPageNr = paginationState.totalNrOfPages;
    }
    setPaginationState({ ...paginationState, pageNr: newPageNr });
  };

  const handleEdit = (review) => {
    setEditReview(review);
  };


  const handleDelete = async (reviewId) => {
    try {
      const token = getStorageToken(stayLoggedIn);
      await deleteProductReviewApi(token, reviewId)
      setUpdateReviews(true);
      setSuccessMsg("Successfully deleted the review.")
    } catch(error){
      setErrorMsg("Could not delete the review. Please try again later.")
    }

  }



  return (
    <Container className="mt-5 justify-content-md-center align-items-center">
      {errorMsg && (
        <ModalMessage
          type="danger"
          message={errorMsg}
          setErrorMsg={setErrorMsg}
        />
      )}
      {successMsg && (
        <ModalMessage
          type="success"
          autoClose={true}
          message={successMsg}
          setSuccessMsg={setSuccessMsg}
        /> 
      )}
      {isLoading && <LoadingSpinner />}
      {editReview && (
        <>
        <ScrollToTop/>
          <h3>Edit Review</h3>
          <ReviewForm
            editReview={editReview}
            setEditReview={setEditReview}
            setUpdateReviews={setUpdateReviews}
            setSuccessMsg={setSuccessMsg}
            setErrorMsg={setErrorMsg}
          />
        </>
      )}
      <h1>My Reviews</h1>
      {reviews && (
        <Row xs={2} md={3} lg={4} className="mt-4 mb-1">
          <Col>
            <SortDropdown
              sortOptions={sortOptions}
              handleChangeSortKey={setSortOption}
            />
          </Col>
          <Col>
            <SortDropdown
              sortOptions={filterOptions}
              heading="Filter By"
              handleChangeSortKey={setFilterOption}
            />
          </Col>
        </Row>
      )}
      {reviews && <ReviewsList
        reviews={reviews}
        editable={true}
        deletable={true}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />}

  {/* PAGINATION MENU */}
      {reviews && reviews.length > 0 && (
        <div style={{marginTop: "2rem"}}>
        <PaginationMenu
          pageNr={paginationState.pageNr}
          totalNrOfPages={paginationState.totalNrOfPages}
          handleChangePageNr={handleChangePageNr}
        />
        </div>
      )}
    </Container>
  );
}
